import router from '@/router'
//
import {
    //
    ORDER_WAIT_PAY,
    ORDER_WAIT_CONSIGNMENT,
    ORDER_WAIT_CUSTOMER_RECEIVE,
    ORDER_WAIT_PRAISE,
    ORDER_AFTER_SALE,
    ORDER_ARRIVED,
    ORDER_PRAISE_SUCCESS,
    ORDER_CANCEL,
} from '@/constants.js'

function goShopAndProduct(shopId, productId = "") {
    router.push({
        path: `/shop?shopId=${shopId}&productId=${productId}`,
    });
}

function goToProductDetail(shopId, productId) {
    router.push({
        path: `productDetail?shopId=${shopId}&productId=${productId}`,
    });
}

function checkOpenTime(openTime, offTime) {
    //
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth()
    const date = now.getDate()

    //
    {
        //
        let [hour, minute] = openTime
            .split(':')
            .map((el) => parseInt(el))

        //
        openTime = new Date(year, month, date, hour, minute)
    }

    {
        //
        let [hour, minute] = offTime
            .split(':')
            .map((el) => parseInt(el))

        //
        offTime = new Date(year, month, date, hour, minute)
    }

    //
    if (
        now.valueOf() >= openTime.valueOf() &&
        now.valueOf() <= offTime.valueOf()
    ) {
        //
        return true
    }

    //
    return false
}

function checkMaxBuyNum(shopId, productId, specificationId)
{
    if(shopId == 2222 && productId == 110250)
    {
        return 1;
    }

    return 99999999;
}

function checkOrderState(orderInfo)
{
    //
    let orderState = 0;

    //
    switch (orderInfo.oNowState) {
        case 1:
            {
                orderState = ORDER_WAIT_PAY;
            }
            break;
        case 2:
            {
                if (orderInfo.subOrders[0].applyForSale == 0
                    && orderInfo.subOrders[0].kdStatus == 0
                    && orderInfo.subOrders[0].receipt == 0) {
                    orderState = ORDER_WAIT_CONSIGNMENT;
                }
                else if (orderInfo.subOrders[0].applyForSale == 0
                    && orderInfo.subOrders[0].kdStatus == 10
                    && orderInfo.subOrders[0].isEvaluation == 0
                    && orderInfo.subOrders[0].receipt == 0) {
                    orderState = ORDER_WAIT_CUSTOMER_RECEIVE;
                }
                else if (orderInfo.subOrders[0].applyForSale == 0
                    && orderInfo.subOrders[0].kdStatus == 10
                    && orderInfo.subOrders[0].isEvaluation == 0
                    && orderInfo.subOrders[0].receipt == 1) {
                    orderState = ORDER_WAIT_PRAISE
                }
                else if (orderInfo.subOrders[0].applyForSale == 0
                    && orderInfo.subOrders[0].kdStatus == 10
                    && orderInfo.subOrders[0].isEvaluation == 1
                    && orderInfo.subOrders[0].receipt == 1) {
                    orderState = ORDER_PRAISE_SUCCESS; // 已评价
                }
                else if (orderInfo.subOrders[0].applyForSale == 1) {
                    orderState = ORDER_AFTER_SALE;
                }
                else if (orderInfo.subOrders[0].applyForSale == 0
                    && orderInfo.subOrders[0].kdStatus == 10
                    && orderInfo.subOrders[0].isEvaluation == 0
                    && orderInfo.subOrders[0].receipt == 0
                    && orderInfo.subOrders[0].ifGetTo == 1) {
                    orderState = ORDER_ARRIVED;
                }
            }
            break;
        case 9:
            {
                orderState = ORDER_CANCEL;
            }
            break;
    }

    //
    return orderState;
}

export {
    goShopAndProduct,
    goToProductDetail,
    checkOpenTime,
    checkMaxBuyNum,
    checkOrderState,
}

export default {
    goShopAndProduct,
    goToProductDetail,
    checkOpenTime,
    checkMaxBuyNum,
    checkOrderState,
}